import React, {Fragment, useEffect, useState} from "react";
import {getParams} from "../../utils/hooks/getParams";
import {useDispatch} from "react-redux";

const FilterWithTrashed = (props) => {
    const dispatch = useDispatch();
    const {getPageItems} = props;

    const [withTrashed, setWithTrashed] = useState(!!getParams().with_trashed || false);
    const [isFirst, setIsFirst] = useState(true);

    useEffect(() => {
        const params = getParams();
        if (!isFirst) {
            dispatch(getPageItems(1, params))
        }
        setIsFirst(false);
    }, [withTrashed])

    const handleChange = () => {
        setWithTrashed(!withTrashed);

        // Get the current URL and params
        const url = new URL(window.location);
        
        // Reset page to 1
        url.searchParams.set('page', 1);
        
        if (!withTrashed) {
            // If we're turning it on, set the param
            url.searchParams.set('with_trashed', String(!withTrashed));
            
            // Remove only_trashed param if it exists (they are mutually exclusive)
            if (url.searchParams.has('only_trashed')) {
                url.searchParams.delete('only_trashed');
            }
        } else {
            // If we're turning it off, remove the param
            url.searchParams.delete('with_trashed');
        }
        
        window.history.pushState({}, '', url);
    };

    return (
        <Fragment>
            <div className="form-check form-switch">
                <input className="form-check-input"
                       type="checkbox"
                       id="filterWithTrashed"
                       onChange={handleChange}
                       checked={withTrashed}
                />
                <label className="form-check-label" htmlFor="filterWithTrashed">
                    O'chirilganlar bilan
                </label>
            </div>
        </Fragment>
    )
}

export default FilterWithTrashed; 